import { render } from "./DneExchange.vue?vue&type=template&id=8fe6d3b4&scoped=true"
import script from "./DneExchange.vue?vue&type=script&lang=js"
export * from "./DneExchange.vue?vue&type=script&lang=js"

import "@/assets/scss/_entitiesPage.scss?vue&type=style&index=0&id=8fe6d3b4&lang=scss&scoped=true"
import "./custom-exchange.scss?vue&type=style&index=1&id=8fe6d3b4&lang=scss&scoped=true"
import "./DneExchange.vue?vue&type=style&index=2&id=8fe6d3b4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe6d3b4"]])

export default __exports__